<template>
  <div>
    <button
      ref="triggerRef"
      @mousedown.stop
      @click="isProfileOpen = !isProfileOpen"
      class="flex items-center gap-2 p-1 pl-1 pr-3 bg-white/20 hover:bg-white/10 border border-white/5 rounded-full hover:border-brand/40 transition-all duration-300 active:scale-95 group cursor-pointer"
    >
      <div
        class="size-8 rounded-full overflow-hidden border border-white/20 shadow-inner relative"
      >
        <img
          v-if="user?.active_profile?.avatar?.url"
          :src="user?.active_profile?.avatar?.url"
          class="w-full h-full rounded-full bg-overlay-dark object-cover group-hover:scale-110 transition-transform duration-500"
        />

        <div
          v-else
          class="w-full h-full rounded-full flex items-center justify-center text-[9px] text-white font-black bg-linear-to-br transition-transform duration-500 group-hover:scale-110"
          :class="getRandomGradient(activeProfile?.id || 0)"
        >
          <div
            class="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.1),transparent_60%)] pointer-events-none"
          />
          <span class="relative z-10">{{
            getInitials(activeProfile?.name)
          }}</span>
        </div>
      </div>
      <LayoutGrid
        :size="16"
        class="text-white/40 group-hover:text-white/80 transition-colors"
      />
    </button>

    <PebbleContentProfileDropdown v-model="isProfileOpen" :ignore-element="triggerRef" />
  </div>
</template>

<script lang="ts" setup>
import { useProfileStore } from "~~/stores/auth/profile";
import { LayoutGrid } from "lucide-vue-next";

const profileStore = useProfileStore();
const { activeProfile } = storeToRefs(profileStore);
const { getInitials } = useStringUtils();

const isProfileOpen = ref(false);
const triggerRef = ref<HTMLElement | null>(null);

// Production-ready gradient fallback styling
const AVATAR_GRADIENTS = [
  "from-indigo-600 to-cyan-500",
  "from-emerald-500 to-teal-700",
  "from-purple-600 to-pink-500",
  "from-amber-500 to-rose-600",
  "from-blue-600 to-violet-600",
  "from-fuchsia-600 to-orange-500",
];

const getRandomGradient = (seed: string | number): string => {
  const hash =
    typeof seed === "string"
      ? seed.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0)
      : seed;
  const index = Math.abs(hash) % AVATAR_GRADIENTS.length;
  return AVATAR_GRADIENTS[index]!;
};

const { user } = useAuth();
</script>
